import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-spin.styles.scss?module';

type SpinSizes = 'small' | 'medium' | 'large';

export default componentFactoryOf()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiSpin',
    props: {
      size: {
        type: String as () => SpinSizes,
        default: 'large'
      }
    },
    render() {
      return <div class={[styles.radialProgress, styles[this.size]]}></div>;
    }
  });
